import React, { useState, useEffect } from "react";
import {
  TextInput,
  Grid,
  FileInput,
  Select,
  Divider,
  Card,
  NumberInput,
  Button,
  Checkbox,
  Text,
  Textarea,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { showNotification } from "@mantine/notifications";
import { DateRangePicker, DatePicker } from "@mantine/dates";
import { apiWithInterceptor } from "../../../../api";
import * as dayjs from "dayjs";
import { useLocation } from "react-router-dom";

const Session = () => {
  const location = useLocation();
  const [forms, setForms] = useState([]);
  const [theaters, setTheaters] = useState([]);
  const { state } = useLocation();

  let startDate;
  let endDate;
  let applyDate;
  let rtlCheck;
  let disabledCheck;
  let autoSendSms;
  let autoSendEmail;
  let sessionType;
  let submissionMessageSms;
  let submissionMessageEmail;
  let submissionMessageEmailTranslation;
  let sendWithTicket;
  let emailRequired;
  let phoneNumberRequired;

  if (location.pathname !== `/app/events/create-session/${state?.id}`) {
    startDate = new Date(
      dayjs(state?.session?.start_date).format("YYYY MM DD")
    );
    endDate = new Date(dayjs(state?.session?.end_date).format("YYYY MM DD"));
    applyDate = new Date(
      dayjs(new Date(state?.session?.applying_start_data)).format("YYYY,MM,DD")
    );
    rtlCheck = state?.session?.rtl;
    disabledCheck = state?.session?.disabled;
    autoSendSms = state?.session?.auto_send_sms;
    autoSendEmail = state?.session?.auto_send_email;
    sessionType = state?.session?.type !== "BASIC_SESSION" ? true : false;
    submissionMessageSms =
      state?.session?.submission_message_sms === null
        ? ""
        : state?.session?.submission_message_sms;
    submissionMessageEmail =
      state?.session?.submission_message_email === null
        ? ""
        : state?.session?.submission_message_email;
    submissionMessageEmailTranslation =
      state?.session?.submission_message_email_translation;
    sendWithTicket = state?.session?.send_with_ticket;
    emailRequired = state?.session?.email_required;
    phoneNumberRequired = state?.session?.phone_number_required;
  } else {
    startDate = new Date();
    endDate = new Date();
    rtlCheck = false;
    disabledCheck = false;
    autoSendSms = false;
    autoSendEmail = false;
    sessionType = false;
    submissionMessageSms = "";
    submissionMessageEmail = "";
    submissionMessageEmailTranslation = "";
    sendWithTicket = false;
    emailRequired = false;
    phoneNumberRequired = false;
  }
  const [value, setValue] = useState([startDate, endDate]);
  const [applyStartDate, setStartDate] = useState(applyDate);
  const [rtlChecked, setRtlChecked] = useState(rtlCheck);
  const [disabledChecked, setDisabledChecked] = useState(disabledCheck);
  const [autoSendSmsState, setAutoSendSmsState] = useState(autoSendSms);
  const [autoSendEmailState, setAutoSendEmailState] = useState(autoSendEmail);
  const [sessionTypeState, setSessionTypeState] = useState(sessionType);
  const [totalCharsValue, setTotalCharsValue] = useState(submissionMessageSms);
  const [emailRequiredState, setEmailRequiredState] = useState(emailRequired);
  const [phoneNumberRequiredState, setPhoneNumberRequiredState] =
    useState(phoneNumberRequired);
  const [sendWithTicketState, setSendWithTicketState] =
    useState(sendWithTicket);

  const handleValueChange = (event) => {
    setTotalCharsValue(event.target.value);
  };
  const characterCount = totalCharsValue?.length;
  const maxCharacterCount = 55; // Set the maximum character count as needed

  let Obj;
  location.pathname !== `/app/events/create-session/${state?.id}`
    ? (Obj = {
        initialValues: {
          sessionName: state?.session?.name,
          sessionNameTranslation: state?.session?.name_translation,
          sessionDescription: state?.session?.description,
          sessionDescriptionTranslation:
            state?.session?.description_translation,
          sessionLocation: state?.session?.location,
          sessionDuration: value,
          applyingStartDate: applyStartDate,
          sessionCover: null,
          totalTickets: state?.session?.total_tickets,
          linkedForm: state?.session?.form_id,
          linkedTheater:
            state?.session?.theater_id === null
              ? null
              : state?.session?.theater_id,
          disableSession: disabledChecked,
          rtl: rtlChecked,
          submissionMessageEmail: state?.session?.submission_message_email,
          submissionMessageEmailTranslation:
            state?.session?.submission_message_email_translation,
        },
      })
    : (Obj = {
        initialValues: {
          sessionName: "",
          sessionNameTranslation: "",
          sessionDescription: "",
          sessionDescriptionTranslation: "",
          sessionLocation: "",
          sessionDuration: "",
          applyingStartDate: null,
          sessionCover: null,
          totalTickets: 0,
          linkedForm: null,
          linkedTheater: null,
          disableSession: disabledChecked,
          rtl: rtlChecked,
          submissionMessageEmail: "",
          submissionMessageEmailTranslation: "",
        },
      });
  const form = useForm(Obj);

  const user = JSON.parse(localStorage.getItem("userInfo"));

  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      event_id: state?.id,
    },
  };

  useEffect(() => {
    user.privileges === "ADMIN"
      ? apiWithInterceptor.get("/form", config).then(function (response) {
          setForms(response.data.array);
        })
      : apiWithInterceptor
          .get(`/form?user_id=${user.id}`, config)
          .then(function (response) {
            setForms(response.data.array);
          })
          .catch(function (error) {
            showNotification({
              title: "Something went wrong",
              message: ` ${error?.response?.data?.message}`,
              color: "red",
            });
          });
  }, []);

  useEffect(() => {
    apiWithInterceptor.get("/theater").then((response) => {
      setTheaters(response.data.array);
    });
  }, []);

  const newForms = forms.map((item) => {
    return {
      value: item.id,
      label: item.name,
    };
  });

  const newTheaters = theaters.map((item) => {
    return {
      value: item.id,
      label: item.name,
    };
  });

  return (
    <>
      <Text>
        Event name:{" "}
        <Text weight={800} span>
          {state?.name}
        </Text>
      </Text>
      <Text>
        Event description:{" "}
        <Text weight={800} span>
          {state?.description}
        </Text>
      </Text>
      <Divider my="sm" label={"Session"} labelPosition="center" />
      <form
        onSubmit={form.onSubmit((values) => {
          const formData = new FormData();
          formData.append("name", values.sessionName);
          formData.append("name_translation", values.sessionNameTranslation);
          formData.append("description", values.sessionDescription);
          formData.append(
            "description_translation",
            values.sessionDescriptionTranslation
          );
          formData.append("cover_image", values.sessionCover);
          formData.append("location", values.sessionLocation);
          formData.append("total_tickets", values.totalTickets);
          formData.append(
            "start_date",
            dayjs(values.sessionDuration[0]).format("YYYY-MM-DD")
          );
          formData.append(
            "end_date",
            dayjs(values.sessionDuration[1]).format("YYYY-MM-DD")
          );
          formData.append(
            "applying_start_data",
            dayjs(values.applyingStartDate).format("YYYY-MM-DD")
          );
          formData.append("acceptance_status", "APPROVED");
          formData.append("event_id", state?.id);
          formData.append("form_id", values.linkedForm);
          if (values.linkedTheater !== null) {
            formData.append("theater_id", values.linkedTheater);
          }
          formData.append("disabled", disabledChecked);
          formData.append("rtl", rtlChecked);
          formData.append("auto_send_sms", autoSendSmsState);
          formData.append("auto_send_email", autoSendEmailState);
          formData.append(
            "type",
            setSessionTypeState === true ? "SURVEY" : "BASIC_SESSION"
          );
          formData.append("submission_message_sms", totalCharsValue);
          formData.append(
            "submission_message_email",
            values.submissionMessageEmail
          );

          formData.append(
            "submission_message_email_translation",
            values.submissionMessageEmailTranslation
          );
          formData.append("send_with_ticket", sendWithTicketState);
          formData.append("email_required", emailRequiredState);
          formData.append("phone_number_required", phoneNumberRequiredState);
          location.pathname === `/app/events/create-session/${state?.id}`
            ? apiWithInterceptor
                .post("/session", formData, config)
                .then(function () {
                  showNotification({
                    title: "Success",
                    message: "Session Created Successfully",
                    color: "green",
                  });
                  form.reset();
                })
                .catch(function (error) {
                  showNotification({
                    title: "Something went wrong",
                    message: `${error?.response?.data?.message}`,
                    color: "red",
                  });
                })
            : apiWithInterceptor
                .patch(`/session/${state?.session?.id}`, formData, config)
                .then(function () {
                  showNotification({
                    title: "Success",
                    message: "Session Updated Successfully",
                    color: "green",
                  });
                  form.reset();
                })
                .catch(function (error) {
                  showNotification({
                    title: "Something went wrong",
                    message: `${error?.response?.data?.message}`,
                    color: "red",
                  });
                });
        })}
      >
        <Card withBorder p={15} sx={{ overflow: "visible" }}>
          <Grid>
            <Grid.Col style={{ display: "flex" }} xs={2}>
              <Checkbox
                size="sm"
                label="Disable Session"
                description="The session is active by default."
                checked={disabledChecked}
                onChange={(event) =>
                  setDisabledChecked(event.currentTarget.checked)
                }
              />
            </Grid.Col>
            <Grid.Col style={{ display: "flex" }} xs={2}>
              <Checkbox
                size="sm"
                label="RTL Language"
                description="Check if language is written from Right to left (Arabic), default is LTR"
                checked={rtlChecked}
                onChange={(event) => setRtlChecked(event.currentTarget.checked)}
              />
            </Grid.Col>
            <Grid.Col style={{ display: "flex" }} xs={2}>
              <Checkbox
                size="sm"
                label="Survey"
                description="Check if this session is survey"
                checked={sessionTypeState}
                onChange={(event) =>
                  setSessionTypeState(event.currentTarget.checked)
                }
              />
            </Grid.Col>
            <Grid.Col style={{ display: "flex" }} xs={2}>
              <Checkbox
                size="sm"
                label="Auto send sms"
                description="Check to auto send sms"
                checked={autoSendSmsState}
                onChange={(event) =>
                  setAutoSendSmsState(event.currentTarget.checked)
                }
              />
            </Grid.Col>
            <Grid.Col style={{ display: "flex" }} xs={2}>
              <Checkbox
                size="sm"
                label="Auto send email"
                description="Check to auto send email"
                checked={autoSendEmailState}
                onChange={(event) =>
                  setAutoSendEmailState(event.currentTarget.checked)
                }
              />
            </Grid.Col>
            <Grid.Col style={{ display: "flex" }} xs={2}>
              <Checkbox
                size="sm"
                label="Auto send with ticket"
                description="Check to auto send email/sms with ticket"
                checked={sendWithTicketState}
                onChange={(event) =>
                  setSendWithTicketState(event.currentTarget.checked)
                }
              />
            </Grid.Col>
            <Grid.Col style={{ display: "flex" }} xs={2}>
              <Checkbox
                size="sm"
                label="Required Email"
                description="Check if you want the email to be required"
                checked={emailRequiredState}
                onChange={(event) =>
                  setEmailRequiredState(event.currentTarget.checked)
                }
              />
            </Grid.Col>
            <Grid.Col style={{ display: "flex" }} xs={2}>
              <Checkbox
                size="sm"
                label="Require Phone Number"
                description="Check if you want the phone number to be required"
                checked={phoneNumberRequiredState}
                onChange={(event) =>
                  setPhoneNumberRequiredState(event.currentTarget.checked)
                }
              />
            </Grid.Col>

            {autoSendEmailState === true ? (
              <>
                <Grid.Col span={12}>
                  <Textarea
                    label="Email letter"
                    autosize={true}
                    maxRows={10}
                    placeholder="Enter the email to auto send"
                    {...form.getInputProps("submissionMessageEmail")}
                  />
                </Grid.Col>
                <Grid.Col span={12}>
                  <Textarea
                    label="Email letter Translation"
                    autosize={true}
                    maxRows={10}
                    placeholder="Enter the email translation to auto send"
                    {...form.getInputProps("submissionMessageEmailTranslation")}
                  />
                </Grid.Col>
              </>
            ) : null}
            {autoSendSmsState === true ? (
              <Grid.Col span={12}>
                <TextInput
                  label="SMS message"
                  placeholder="Enter the sms to auto send maximum is 55 character"
                  value={totalCharsValue}
                  onChange={handleValueChange}
                  rightSection={
                    <span
                      style={{
                        color: "lightgray",
                        fontSize: "15px",
                        marginRight: "15px",
                      }}
                    >
                      {characterCount}/{maxCharacterCount}
                    </span>
                  }
                  error={
                    characterCount > maxCharacterCount
                      ? "Too many characters this will cost much more credit to send"
                      : null
                  }
                />
              </Grid.Col>
            ) : null}
            <Grid.Col span={12}>
              <Grid>
                <Grid.Col span={6}>
                  <TextInput
                    label="Session Name"
                    placeholder="Session Name"
                    {...form.getInputProps("sessionName")}
                  />
                </Grid.Col>
                <Grid.Col span={6}>
                  <TextInput
                    label="Session name translated in Arabic"
                    placeholder="Session name in Arabic"
                    {...form.getInputProps("sessionNameTranslation")}
                  />
                </Grid.Col>
              </Grid>
            </Grid.Col>
            <Grid.Col span={12}>
              <Textarea
                label="Session Description"
                autosize={true}
                maxRows={10}
                placeholder="Session Description"
                {...form.getInputProps("sessionDescription")}
              />
            </Grid.Col>
            <Grid.Col span={12}>
              <Textarea
                label="Session Description Translated"
                autosize={true}
                maxRows={10}
                placeholder="Session Description Translated in Arabic"
                {...form.getInputProps("sessionDescriptionTranslation")}
              />
            </Grid.Col>

            <Grid.Col span={12}>
              <FileInput
                label="Session Cover"
                placeholder="Session Cover"
                accept="image/png,image/jpeg,image/jpg"
                clearable={true}
                {...form.getInputProps("sessionCover")}
              />
            </Grid.Col>

            <Grid.Col span={12}>
              <TextInput
                label="Session Location"
                placeholder="Session Location"
                {...form.getInputProps("sessionLocation")}
              />
            </Grid.Col>

            <Grid.Col span={12}>
              <NumberInput
                label="Total Tickets"
                placeholder="Total Tickets"
                min={0}
                {...form.getInputProps("totalTickets")}
              />
            </Grid.Col>

            <Grid.Col span={12}>
              <DateRangePicker
                label="Session Duration"
                placeholder="Pick dates range"
                value={value}
                onChange={setValue}
                {...form.getInputProps("sessionDuration")}
              />
            </Grid.Col>
            <Grid.Col span={12}>
              <DatePicker
                label="Applying start date"
                placeholder="Pick date"
                value={applyStartDate}
                onChange={setStartDate}
                {...form.getInputProps("applyingStartDate")}
              />
            </Grid.Col>

            <Grid.Col span={12}>
              <Select
                disabled={
                  location.pathname ===
                  `/app/events/create-session/${state?.id}`
                    ? false
                    : true
                }
                label="Choose Session Form"
                placeholder="Pick one"
                searchable
                description={
                  location.pathname ===
                  `/app/events/create-session/${state?.id}`
                    ? "Choose carefully you can't change this choice later !!!"
                    : "Form no longer changeable after being initialized "
                }
                nothingFound="Form not found"
                data={newForms}
                {...form.getInputProps("linkedForm")}
              />
            </Grid.Col>
            <Grid.Col span={12}>
              <Select
                disabled={
                  location.pathname ===
                  `/app/events/create-session/${state?.id}`
                    ? false
                    : true
                }
                label="Choose Theater"
                placeholder="Pick one"
                searchable
                description={
                  location.pathname ===
                  `/app/events/create-session/${state?.id}`
                    ? "Choose carefully you can't change this choice later !!!"
                    : "Theater no longer changeable after being initialized "
                }
                nothingFound="Theater not found"
                data={newTheaters}
                {...form.getInputProps("linkedTheater")}
              />
            </Grid.Col>
            <Grid.Col>
              <Button mt={"lg"} type="submit">
                {location.pathname === `/app/events/create-session/${state?.id}`
                  ? "Create Session"
                  : "Update Session"}
              </Button>
            </Grid.Col>
          </Grid>
        </Card>
      </form>
    </>
  );
};

export default Session;
